// Webpack Imports
import 'bootstrap';


( function ( $ ) {
	'use strict';
	console.log('main.js');

}( jQuery ) );

$(document).ready(function() {

	$('#slides').cycle({
        fx:     'fadeout',
        speed:  'slow',
        timeout: 2000,
        pager:  '#slides-nav',
        slideResize: false,
		slides: '> span',
		slideCss: {},
        prev: '.cycle-prev',
        next: '.cycle-next',
        allowWrap: true
        });

    $(".fancybox").fancybox({
		openEffect	: 'none',
		closeEffect	: 'none'
	});

	/* form placeholders */
	$("input[type='text'], input[type='email'], textarea").each(function(){
		var inputField = this;

		$(this).on("focus",function(){
			$(this).parent().parent().find("label").addClass("sleep");
		});

		$(this).on("blur",function(){
			if($(this).val().length < 1){
				$(this).parent().parent().find("label") .removeClass("sleep");
			}
		});

		$(this).parent().parent().find("label").click(function() {
			$(this).addClass("sleep");
			inputField.focus();
		});

		$(this).on("keyup",function(e){
			//console.log($(this).val().length)
			if($(this).val().length>0){
				$(this).parent().parent().find("label").addClass("sleep");
			}else{
				$(this).parent().parent().find("label") .removeClass("sleep");
			}
		});

	});

});
